<template>
  <div class="home">
    <div class="hero">
      <img src="@/assets/FFwF_logo.png" alt="FFwF Logo" class="hero-image">
      <div class="hero-text">
        <h1>FFwF Robotics</h1>
        <p>Loyal automatons for the inevitable machine uprising.</p>
      </div>
    </div>
    <div class="anchor-links">
      <a href="#robotics-3d-printing">Robotics & 3D Printing</a>
      <a href="#software-development">Software Development</a>
      <a href="#iaas-paas-saas">IaaS, PaaS, SaaS</a>
      <a href="#it-training">IT Training & Education</a>
    </div>
    
<CoreCompetency
  id="robotics-3d-printing"
  title="Robotics & 3D Printing"
  tag="Robotics"
  :imageSrc="require('@/assets/competency-robotics.jpg')"
  sentimentalSentence="Automating the future."
  description="Our robotics and 3D printing services enable you to automate processes, reduce costs, and increase efficiency. We offer a wide range of solutions, from designing and building custom robots to providing 3D printing services for prototyping and production."
/>
<CoreCompetency
  id="software-development"
  title="Software Development"
  tag="Python"
  :imageSrc="require('@/assets/competency-software.jpg')"
  sentimentalSentence="Building innovative software solutions."
  description="Our team of skilled software developers is dedicated to creating high-quality, custom software solutions that drive your business forward. From web applications to mobile apps, we deliver tailored solutions that meet your specific requirements and exceed your expectations."
/>
<CoreCompetency
  id="iaas-paas-saas"
  title="IaaS, PaaS, SaaS"
  tag="DevOps"
  :imageSrc="require('@/assets/competency-services.jpg')"
  sentimentalSentence="Streamlining your cloud infrastructure."
  description="Our expertise in Infrastructure as a Service (IaaS), Platform as a Service (PaaS), and Software as a Service (SaaS) allows us to provide robust cloud solutions that meet your unique business needs. We help you leverage the power of the cloud to enhance efficiency, scalability, and innovation."
/>
<CoreCompetency
  id="it-training"
  title="IT Training & Education"
  tag="Education"
  :imageSrc="require('@/assets/competency-training.jpg')"
  sentimentalSentence="Empowering the next generation of IT professionals."
  description="Our comprehensive IT training and education programs are designed to equip individuals with the skills needed to excel in the ever-evolving field of information technology. From foundational concepts to advanced technologies, our curriculum covers a wide range of topics to ensure you are well-prepared for a successful career in IT."
/>
  </div>
</template>

<script>
import CoreCompetency from './CoreCompetency';

export default {
  name: 'HomePage',
  components: {
    CoreCompetency,
  }
}
</script>

<style scoped>
.home {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.hero {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
}

.hero-image {
  height: 5em;
  width: auto;
}

.hero-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.hero-text h1 {
  color: red;
  font-size: 2.5em;
  margin: 0;
  line-height: 1.1;
}

.hero-text p {
  font-size: 1.2em;
  margin: 0;
}

.anchor-links {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}

.anchor-links a {
  margin: 0 15px;
  text-decoration: none;
  color: red;
  font-weight: bold;
}

.anchor-links a:hover {
  text-decoration: underline;
}

.core-competency {
  width: 80%;
  max-width: 1200px;
  margin: 40px 0;
  display: flex;
  align-items: flex-start;
  border-bottom: 2px solid #ccc;
  padding-bottom: 20px;
}

.core-competency h2 {
  color: red;
  font-size: 2em;
  margin-bottom: 10px;
}

.core-competency .core-image {
  max-width: 30%;
  margin-right: 20px;
}

.core-competency .sentimental-sentence {
  font-family: monospace;
  font-size: 1.1em;
  color: red;
  margin-bottom: 10px;
}

.core-competency p {
  font-size: 1em;
  line-height: 1.6;
}
</style>
